/*
 * @Description: '产品中心'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2021-08-27 17:22:44
 */

export default [
  {
    path: '/product',
    component: resolve => require(['@/views/product'], resolve),
    name: 'Product',
    meta: {
        title: '产品中心'
    }
  },
  {
    path: 'product/:id',
    component: resolve => require(['@/views/product'], resolve),
    name: 'ProductList1',
    meta: {
      title: '产品中心'
    }
  },
  {
    path: 'product/:id/:childrenId',
    component: resolve => require(['@/views/product'], resolve),
    name: 'ProductList2',
    // hidden: true,
    meta: {
      title: '产品中心',
      noBefor: true
    }
  },
  {
    path: 'productDetail/:id',
    component: resolve => require(['@/views/product/detail'], resolve),
    name: 'ProductDetail',
    meta: {
      title: '产品中心',
      guidePath: true,
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/product.js